import type { ShopifyContractLine } from '../types';

export function sortDiscountsForDisplay<T extends { description: string }>(items: T[]): T[] {
  const key = (d: T) => {
    const lower = d.description.toLowerCase();
    if (lower.includes('volume discount')) return 2;
    if (lower.includes('discount') || lower.includes('other')) return 1;
    return 0;
  };
  return [...items].sort((a, b) => key(a) - key(b) || a.description.localeCompare(b.description));
}

export function formatNextOrderDate(isoDate: string | null): string | null {
  if (!isoDate) return null;
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return null;
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const year = String(d.getUTCFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
}

export function isOrderNotDueYet(isoDate: string | null): boolean {
  if (!isoDate) return false;
  const d = new Date(isoDate);
  return !Number.isNaN(d.getTime()) && d.getTime() > Date.now();
}

export function formatPrice(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '-';
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(n)) return '-';
  return `£${n.toFixed(2)}`;
}

export function formatDiscountAmount(
  amount: number | string | null | undefined,
  isPercentage: boolean,
): string {
  if (amount === null || amount === undefined) return '-';
  const n = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(n)) return '-';
  if (isPercentage) return `${n}%`;
  return `£${n.toFixed(2)}`;
}

export function lineSubtotal(line: ShopifyContractLine): number | null {
  const qty = line.quantity != null ? Number(line.quantity) : NaN;
  if (Number.isNaN(qty) || qty <= 0) return null;
  if (line.discountedPrice != null && line.discountedPrice !== '') {
    const total = Number(line.discountedPrice);
    return Number.isNaN(total) ? null : total;
  }
  const unitPrice = line.linePrice != null ? Number(line.linePrice) : NaN;
  if (Number.isNaN(unitPrice)) return null;
  return qty * unitPrice;
}

export function linesSubtotalBeforeDiscount(lines: ShopifyContractLine[]): number {
  return lines.reduce((sum, line) => {
    const qty = line.quantity != null ? Number(line.quantity) : 0;
    const price = line.linePrice != null ? Number(line.linePrice) : 0;
    return sum + qty * price;
  }, 0);
}
